import React from'react';import PropTypes from'prop-types';import{subgroup}from"./style";/**
 * Renders a product properties group header.
 * @param {Object} props The component props.
 * @return {JSX}
 */var Group=function Group(_ref){var group=_ref.group;return React.createElement("tr",null,React.createElement("td",{colSpan:"2",className:subgroup},React.createElement("span",{dangerouslySetInnerHTML:{__html:group}})));};export default React.memo(Group);